import { render, staticRenderFns } from "./forex-calendar.vue?vue&type=template&id=9d5157a2&scoped=true"
import script from "./forex-calendar.vue?vue&type=script&lang=js"
export * from "./forex-calendar.vue?vue&type=script&lang=js"
import style0 from "./forex-calendar.vue?vue&type=style&index=0&id=9d5157a2&prod&lang=css"
import style1 from "./forex-calendar.vue?vue&type=style&index=1&id=9d5157a2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9d5157a2",
  null
  
)

export default component.exports